
/**
 * This file is part of the Packet.js DI package.
 *
 * (c) Francisco Ruiz <faruiz.github@gmail.com>
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import { Container } from './core';

const container = Container.getContainer();

export {
  container as default,
  Container,
};
